/* eslint no-unused-vars: 0 */
import React, { Component } from 'react';

import { Link, browserHistory } from 'react-router';

/* eslint max-len: 0 */
export default class LinkErrorPage extends Component {
    componentWillMount() {
        if (this.props.location !== '404') {
            browserHistory.push('404');
        }
    }

    render() {
        return (
            <div className="app__message-page__container">
                <p className="semi-bold push-down-30">Page not found</p>
                <Link to="/">Go to home page</Link>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/Page404.jsx